const sysManageZh = {
  sysManageLang: {
    系统总览: '系统总览',
    批量添加: '批量添加',
    添加系统: '添加系统',
    当需要添加的系统较多时可点击批量添加按钮批量添加请先: '当需要添加的系统较多时，可点击批量添加按钮。（批量添加请先',
    下载Excel模板: '下载Excel模板',
    填写完成后再进行上传提交: ' ，填写完成后再进行上传提交）',
    请选择归属: '请选择归属',
    请输入内容例如EMS编号归属系统编号ICCID: '请输入内容，例如EMS编号、归属、系统编号、ICCID',
    查询: '查询',
    重置: '重置',
    批量操作: '批量操作',
    当前已选: '当前已选',
    项: '项',
    取消: '取消',
    批量分配: '批量分配',
    序号: '序号',
    系统编号: '系统编号',
    系统名称: '系统名称',
    EMS编号: 'EMS编号',
    ICCID: 'ICCID',
    归属状态: '归属状态',
    暂无归属: '暂无归属',
    电站: '电站',
    客户: '客户',
    归属: '归属',
    冷却方式: '冷却方式',
    额定功率: '额定功率',
    标称电压: '标称电压',
    尺寸: '尺寸',
    重量: '重量',
    操作: '操作',
    查看: '查看',
    修改: '修改',
    是否确认删除系统操作: '是否确认删除系统操作？',
    删除: '删除',
    系统分配: '系统分配',
    是否确认撤回此次分配操作: '是否确认撤回此次分配操作？',
    系统撤回: '系统撤回',
    控制配置: '控制配置',
    设备录入: '设备录入',
    暂无数据: '暂无数据',
    基础信息: '基础信息',
    请输入系统编号: '请输入系统编号',
    自定义系统编号名称: '自定义系统编号名称',
    请输入EMS编号: '请输入EMS编号',
    规格参数: '规格参数',
    请输入额定功率: '请输入额定功率',
    额定功率数值范围大于0小于1000000: '额定功率数值范围大于0小于1000000',
    小数点后不允许超过1位: '小数点后不允许超过1位',
    额定容量: '额定容量',
    请输入额定容量: '请输入额定容量',
    额定容量数值范围大于0小于1000000: '额定容量数值范围大于0小于1000000',
    请选择冷却方式: '请选择冷却方式',
    请输入标称电压: '请输入标称电压',
    标称电压数值范围大于0小于1000000: '标称电压数值范围大于0小于1000000',
    请输入重量: '请输入重量',
    重量数值范围大于0小于1000000: '重量数值范围大于0小于1000000',
    请输入尺寸长宽高: '请输入尺寸(长*宽*高)',
    确定: '确定',
    查看系统: '查看系统',
    系统批量分配: '系统批量分配',
    系统分配: '系统分配',
    当前: '当前',
    选择电站名称: '选择电站名称',
    厂家: '厂家',
    输入厂家编码: '输入厂家编码',
    文件上传完成后点击提交按钮以完成导入: '文件上传完成后，点击提交按钮以完成导入',
    文件大小: '文件大小',
    上传日期: '上传日期',
    点击上传: '点击上传',
    拖拽到此区域: '拖拽到此区域',
    重新上传: '重新上传',
    请上传Excel文件文件大小在1M内: '请上传Excel文件，文件大小在1M内',
    文件大小不符合规则请上传Excel文件文件大小在1M内: '文件大小不符合规则，请上传Excel文件，文件大小在1M内',
    全部: '全部',
    未归属: '未归属',
    风冷: '风冷',
    液冷: '液冷',
    其它: '其它',
    无: '无',
    小数点后不允许超过1位: '小数点后不允许超过1位',
    修改系统: '修改系统',
    请选择分配电站: '请选择分配电站！',
    系统已成功分配给: '系统已成功分配给',
    请输入客户编码: '请输入客户编码',
    EMS系统批量导入模板: 'EMS系统批量导入模板.xlsx',
    请上传格式内容正确文件: '请上传格式内容正确文件！',
    系统列表Excel已成功导入: '系统列表Excel已成功导入！',
    已成功导入: '已成功导入',
    条数据: '条数据',
    失败: '失败 ',
    条: '条',
    请下载文件查看失败原因: '请下载文件查看失败原因！',
    提示: '提示',

    系统列表Excel导入失败请检查后重新尝试: '系统列表Excel导入失败，请检查后重新尝试！',
    请使用模板文件的格式进行上传上传文件只能是xlsxlsx格式: '请使用模板文件的格式进行上传，上传文件只能是 xls、xlsx格式！',
    请使用模板文件的格式进行上传上传文件大小不可超过1M: '请使用模板文件的格式进行上传，上传文件大小不可超过1M！',
    系统信息为空请重新上传: '系统信息为空，请重新上传！',
    设备监控: '设备监控',

    系统管理: '系统管理',
    默认开启能量管理下的手动能量控制防过载防逆流功能可选中或取消控制配置点击确认以下发: '默认开启能量管理下的手动能量控制、防过载、防逆流功能，可选中或取消控制配置，点击确认以下发！',
    引用配置: '引用配置',
    系统控制: '系统控制',
    手动控制: '手动控制',
    BMS二级保护: 'BMS二级保护',
    能量管理: '能量管理',
    能量控制: '能量控制',
    SOC参数设置: 'SOC参数设置',
    过载保护: '过载保护',
    防逆流: '防逆流',
    防逆流时段: '防逆流时段',
    PCS启停: 'PCS启停',
    PCS模式控制: 'PCS模式控制',
    PCS并离网控制: 'PCS并离网控制',
    二级保护参数设置: '二级保护参数设置',
    设备控制: '设备控制',
    空调: '空调',
    消防: '消防',
    充电桩: '充电桩',
    光伏: '光伏',
    柴发: '柴发',
    空调启停: '空调启停',
    空调工作模式设置: '空调工作模式设置',
    空调参数设置: '空调参数设置',
    TMS工作模式设置: 'TMS工作模式设置',
    TMS参数设置: 'TMS参数设置',
    消防启停: '消防启停',
    UPS启停: 'UPS启停',
    充电桩启停: '充电桩启停',
    BMS并离网: 'BMS并离网',
    BMS脱扣控制: 'BMS脱扣控制',
    BMS软件复位: 'BMS软件复位',
    故障复位: '故障复位',
    光伏启停: '光伏启停',
    光伏复位: '光伏复位',
    DCDC启停控制: 'DCDC启停控制',
    DCDC故障复位控制: 'DCDC故障复位控制',
    柴发启停: '柴发启停',

    确认: '确认',
    请选择要引用配置的系统引用后将会覆盖当前内容: '请选择要引用配置的系统，引用后将会覆盖当前内容！',
    选择系统: '选择系统',
    请选择: '请选择',

    新增设备: '新增设备',
    添加设备后请填写设备信息其中序号和设备ID为必填项厂家和型号为非必填项: '添加设备后请填写设备信息，其中序号和设备ID为必填项，厂家和型号为非必填项。',
    是否确认删除当前设备: '是否确认删除当前设备？',
    设备id: '设备id',
    型号: '型号',
    电表: '电表',
    设备ID: '设备ID',
    调速器: '调速器',
    外设: '外设',
    除湿器: '除湿器',
    环境监测: '环境监测',
    光伏逆变器: '光伏逆变器',
    箱变: '箱变',
    综合保护设备: '综合保护设备',
    请确认是否保存当前设备录入信息: '请确认是否保存当前设备录入信息！',
    请确认是否取消当前设备录入配置退出页面后录入信息不会保存需重新录入: '请确认是否取消当前设备录入配置，退出页面后录入信息不会保存，需重新录入！',
    是否要删除当前选择的设备: '是否要删除当前选择的设备？',
    请选择要引用配置的系统引用后将会覆盖当前配置内容: '请选择要引用配置的系统,引用后将会覆盖当前配置内容！',
    可选中设备后输入设备数量点击确认新增设备: '可选中设备后输入设备数量,点击确认新增设备。',
    数量: '数量',
    储能电表: '储能电表',
    电池堆: '电池堆',
    电池簇: '电池簇',
    PCS: 'PCS',
    BMS: 'BMS',
    TMS: 'TMS',
    UPS: 'UPS',
    DCDC: 'DCDC',
    PV: 'PV',
    ATS: 'ATS',
    电网连接点电表_低压侧: '电网连接点电表_低压侧',
    电网连接点电表_高压侧: '电网连接点电表_高压侧',
    负载电表: '负载电表',
    光伏电表: '光伏电表',
    储能监测电表: '储能监测电表',
    请输入: '请输入',
    只能输入数值: '只能输入数值',
    字母数字下划线组成: '字母数字下划线组成',
    设备ID长度为150: '设备ID长度为150',
    输入的数量必须是整型数值: '输入的数量必须是整型数值',
    信息不能为空: '信息不能为空',
    设备序号或者设备Id不能重复: '设备序号或者设备Id不能重复',
    设备录入成功: '设备录入成功！',
    若填写电池堆数量电池堆下至少电池簇数量填1不能为空: '若填写电池堆数量，电池堆下至少电池簇数量填1，不能为空！'
  }
}
export default sysManageZh
